const locale: Locale = {
  ko: {
    termsOfUse: '서비스 이용 약관',
    privacy: '개인정보수집 및 이용 동의',
  },
  en: {
    termsOfUse: 'Terms of Use',
    privacy: 'Privacy Policy',
  },
}

export default locale
